import { Stack, Typography } from '@mui/material';
import {
	productDetailsPriceSX,
	productDetailsPriceOfferSX,
} from '@/components/blocks/ProductDetails/styles/priceStrikethru';
import { combineSX } from '@/utils/combineSX';

interface DpProductDetailsPriceProps {
	discount?: string | null;
	price?: string | null;
}

export const DpProductDetailsPrice = ({ discount, price }: DpProductDetailsPriceProps) => (
	<Stack direction="row" spacing={2} sx={{ marginTop: '9px' }}>
		<Typography
			component="span"
			data-testid="offer-price"
			id="offer-price"
			sx={combineSX([productDetailsPriceSX, { textDecoration: 'line-through' }])}
		>
			{price}
		</Typography>
		{discount ? (
			<Typography
				component="span"
				data-testid="offer-price"
				id="offer-price"
				sx={productDetailsPriceOfferSX}
			>
				{discount}
			</Typography>
		) : null}
	</Stack>
);
